/**
 * LogoSection Component
 *
 * Branding area at the top of the SidePanel.
 * Shows the VoiceRecipe logo (waveform + wordmark) when expanded.
 * When collapsed, the SidePanel hides this component entirely
 * and only shows the expand button.
 *
 * Requirements: 1.3
 */

import { Box } from '@mui/material';
import { VoiceRecipeLogo } from './VoiceRecipeLogo';

export interface LogoSectionProps {
    collapsed: boolean;
}

export function LogoSection({ collapsed }: LogoSectionProps) {
    if (collapsed) return null;

    return (
        <Box data-testid="logo-full">
            <VoiceRecipeLogo size="small" />
        </Box>
    );
}
